<ion-card>
  <ion-header>
    <ion-toolbar>
      <ion-title>{{ message.title }}</ion-title>

      <ion-buttons slot="end">
        <ion-button (click)="close()"><ion-icon name="close"></ion-icon></ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-card-header>
    <ion-card-subtitle>
      <div class="header-meta">
        <div>Od: {{ message.publishedByUser.fullName() }}</div>
        <div>{{ message.publishedAt | date: 'dd.MM.yyyy HH:mm' }}</div>
      </div>
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content class="message-content">
    <div [innerHTML]="message.content | bypassHtmlSanitizer"></div>

    <div *ngIf="message.attachmentUri" class="attachments">
      <div>Přílohy:</div>
      <ul>
        <li (click)="viewAttachment(message)">
          <a>{{ FileUploadService.parseFileNameFromUrl(message.attachmentUri) }}</a>
        </li>
      </ul>
    </div>
  </ion-card-content>

  <ion-footer>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button (click)="close()">Zpět</ion-button>
      </ion-buttons>

      <ion-buttons slot="end">
        <ion-button (click)="replyToMessage()">Odpovědět</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-footer>
</ion-card>
